import * as React from 'react';

const LegacyListboxInternalContext = /*#__PURE__*/ React.createContext(undefined);
const LegacyListboxInternalContextProvider = ({ children })=>{
    const [labelMap, setLabelMap] = React.useState({});
    const value = React.useMemo(()=>{
        return {
            labelMap,
            setLabelMap
        };
    }, [
        labelMap,
        setLabelMap
    ]);
    return /*#__PURE__*/ React.createElement(LegacyListboxInternalContext.Provider, {
        value: value
    }, children);
};
function useLegacyListboxInternalContext() {
    const ctx = React.useContext(LegacyListboxInternalContext);
    if (!ctx) {
        throw new Error(`useLegacyListboxInternalContext should be used inside LegacyListboxInternalContext`);
    }
    return ctx;
}

export { LegacyListboxInternalContextProvider, useLegacyListboxInternalContext };
